/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Defaulttitle1Inputs */

const zh_learn_defaulttitle1 = /** @type {(inputs: Learn_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学习资源 | StudyOS Learn`)
};

const en_learn_defaulttitle1 = /** @type {(inputs: Learn_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learning Resource | StudyOS Learn`)
};

const es_learn_defaulttitle1 = /** @type {(inputs: Learn_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recurso de aprendizaje | StudyOS Learn`)
};

/**
* | output |
* | --- |
* | "Learning Resource \| StudyOS Learn" |
*
* @param {Learn_Defaulttitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_defaulttitle1 = /** @type {((inputs?: Learn_Defaulttitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Defaulttitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_defaulttitle1(inputs)
	if (locale === "en") return en_learn_defaulttitle1(inputs)
	return es_learn_defaulttitle1(inputs)
});
export { learn_defaulttitle1 as "learn_defaultTitle" }